export enum LanguageType {
  EN_CA = "EN_CA",
  FR_CA = "FR_CA",
}
